import React, { useState, useMemo } from "react";

import { LocationActivityTableControls } from "./Controls";
import { LocationActivityTableHeader } from "./Header";
import { LocationActivityTableItem } from "./Item";
import {
  defaultLocationActivityQueryParams,
  LocationActivityQueryParams,
  LocationActivityQueryParamsSchema,
} from "./types";
import useLocationsActivity from "../../../containers/FacilityDetailsPage/hooks/useLocationsActivity";
import { useSearchQuery } from "../../../hooks/queries";
import { LocationActivityLog } from "../../../models/LocationActivityLog";
import LocalStorageSvc from "../../../services/localStorageSvc";
import Pagination from "../../Pagination";

export const LocationActivityTable: React.FunctionComponent = () => {
  const configData =
    LocalStorageSvc.getItem<LocationActivityQueryParams>(
      "LocationActivityTable_Config",
      LocationActivityQueryParamsSchema
    ) || defaultLocationActivityQueryParams;

  // Attempt to fetch locationName from URL search parameter if it exists
  const searchQuery = useSearchQuery();
  const locationName = searchQuery.locationName?.toString();

  if (locationName) {
    configData.locationName = locationName;
  }

  const [queryParams, setQueryParams] =
    useState<LocationActivityQueryParams>(configData);

  const { data, isLoading } = useLocationsActivity(queryParams);

  const paginationData = useMemo(() => {
    const currentPageIndex =
      Math.floor(queryParams.offset / queryParams.limit) + 1;
    return {
      ...queryParams,
      pageIndex: currentPageIndex,
      numberPerPage: queryParams.limit,
    };
  }, [queryParams]);

  const handleSort = (sortField: string) => {
    setQueryParams((prev) => {
      const newOrder =
        prev.sort === sortField
          ? prev.order === "asc"
            ? "desc"
            : "asc"
          : "desc";
      const newValue = {
        ...prev,
        sort: sortField,
        order: newOrder,
      };

      LocalStorageSvc.setItem("LocationActivityTable_Config", newValue);

      return newValue;
    });
  };

  return (
    <div className="white-border-panel">
      <LocationActivityTableControls
        value={queryParams}
        onChange={(value) => setQueryParams(value)}
      />
      <LocationActivityTableHeader
        sortField={queryParams.sort}
        sortDirection={queryParams.order}
        handleSort={handleSort}
      />
      {!isLoading &&
        data?.data?.map((item: LocationActivityLog) => (
          <LocationActivityTableItem data={item} key={item.id} />
        ))}

      <div>
        <Pagination
          filterFormData={paginationData}
          totalRowsNumber={data?.count || 0}
          onChangeFilterFormData={(newFilterFormData) => {
            const newPageIndex = newFilterFormData.pageIndex;
            const newOffset = (newPageIndex - 1) * queryParams.limit;

            setQueryParams({
              ...queryParams,
              offset: newOffset,
            });
          }}
        />
      </div>
    </div>
  );
};
